var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageRulesInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Manage Rules"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M53.333 13.4502H59.9997C61.7678 13.4502 63.4635 14.1526 64.7137 15.4028C65.964 16.6531 66.6663 18.3488 66.6663 20.1169V66.7835C66.6663 68.5516 65.964 70.2473 64.7137 71.4976C63.4635 72.7478 61.7678 73.4502 59.9997 73.4502H19.9997C18.2316 73.4502 16.5359 72.7478 15.2856 71.4976C14.0354 70.2473 13.333 68.5516 13.333 66.7835V20.1169C13.333 18.3488 14.0354 16.6531 15.2856 15.4028C16.5359 14.1526 18.2316 13.4502 19.9997 13.4502H26.6663",
    stroke: "#C7C4C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.667 33.4502L56.667 33.4502",
    stroke: "#C7C4C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30 30.1172L23.5714 36.7839L20 34.3596",
    stroke: "#C7C4C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M26.6667 43.4502L20 50.1169",
    stroke: "#C7C4C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M20 43.4502L26.6667 50.1169",
    stroke: "#C7C4C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30 56.7842L23.5714 63.4508L20 61.0266",
    stroke: "#C7C4C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M36.667 46.7842L56.667 46.7842",
    stroke: "#C7C4C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.667 60.1172L56.667 60.1172",
    stroke: "#C7C4C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M50.0003 6.78418H30.0003C28.1594 6.78418 26.667 8.27656 26.667 10.1175V16.7842C26.667 18.6251 28.1594 20.1175 30.0003 20.1175H50.0003C51.8413 20.1175 53.3337 18.6251 53.3337 16.7842V10.1175C53.3337 8.27656 51.8413 6.78418 50.0003 6.78418Z",
    stroke: "#C7C4C5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageRulesInactive);
export default __webpack_public_path__ + "static/media/manage-rules-inactive.bad9f367cfd58a0b03eedddf1ffa9377.svg";
export { ForwardRef as ReactComponent };